export const INITIAL_PAGINATION_QUERY = { page: 1, page_size: 10 };
